import React from 'react';
import {
    Table, Whisper, Popover,
} from 'rsuite';

const { Cell } = Table;

/**
 * A reusable table cell component with tooltip functionality for AuditReport
 * @param {{
 *  rowData?: any,
 *  dataKey: string,
 *  getValue: (rowData: any) => string | null | undefined,
 * }} AuditReportTooltipCellProps
 */
const AuditReportTooltipCell = ({
    rowData, dataKey, getValue, ...props
}) => (
    <Cell
        {...props}
        dataKey={dataKey}
        style={{ cursor: 'default' }}
    >
        {(cellRowData) => {
            const data = rowData || cellRowData;
            const value = getValue(data);

            if (!value) return null;

            return (
                <Whisper
                    delay={500}
                    delayOpen={500}
                    delayClose={500}
                    placement="autoVerticalStart"
                    speaker={<Popover visible>{value}</Popover>}
                >
                    <span>{value}</span>
                </Whisper>
            );
        }}
    </Cell>
);

export default AuditReportTooltipCell;

